<template>
    <div>
        <div class="content-caption dashed">
            <span>折旧范围</span>
            <a class="swb-btn-link" @click="selectDeprScope()">选择</a>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="deprScopeList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="type" label="类型"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, Routes, MsgBox } from '../../app.vues'
    //
    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-asset-depr-comp',
        desc: '资产折旧计算',
        props: {},
        data: function () {
            return {
                deprInfo: {},
                deprScopeList: []
            }
        },
        created: function () {
        },
        methods: {
            // 选择折旧范围
            selectDeprScope: function () {
                let deprScopeList = this.deprScopeList || [];
                let dataList = [];
                for(let i = 0; i < dataList.length; i++) {
                    let dataInfo = dataList[i];

                }
            },
            //
            getDlgResult() {
                let result = {};
                let deprScopeList = this.deprScopeList || [];
                if(deprScopeList.length <= 0) {
                    result.type = "warn";
                    result.message = "请选择折旧范围";
                } else {
                    result.type = "info";
                    result.data = deprScopeList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetDeprComp.vue